<template>
  <div>
    <b-card no-body>
      <b-card-body class="px-2 pt-2 pb-0">
        <b-row>
          <b-col xl="4" lg="4" md="6" sm="12" class="text-left mb-1">
            <b-form-group label-for="filterInput" class="mb-0">
              <b-button variant="gradient-primary" size="sm" class="mr-1" @click="traerData" :disabled="loading"
                v-b-tooltip.hover.top="'Recargar Datos'">
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading" />
              </b-button>
              <b-button v-if="$can('create', 'Pr Ma Fe Area')" variant="gradient-primary" size="sm" class="mr-1"
                v-b-modal.modal-crear v-b-tooltip.hover.top="'Crear Usuario'">
                <font-awesome-icon icon="fa-solid fa-plus" />
              </b-button>

              <b-button v-if="$can('create', 'Pr Ma Fe Area')" variant="gradient-primary" size="sm" class="mr-1"
                :disabled="loadingExp" @click="exportarDataExcel" v-b-tooltip.hover.top="'Exportar Excel'">
                <font-awesome-icon v-if="loadingExp" icon="fa-solid fa-arrows-rotate" spin />
                <font-awesome-icon v-else icon="fa-solid fa-file-excel" />
              </b-button>
              <b-button v-if="$can('create', 'Pr Ma Fe Area')" variant="gradient-primary" size="sm" class="mr-1"
                :disabled="loadingExp" @click="borrarFiltroGeneral" v-b-tooltip.hover.top="'Limpiar Filtro'">
                <font-awesome-icon icon="fa-solid fa-filter-circle-xmark" />
              </b-button>
            </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="6" sm="12" class="text-center mb-1 font-medium-1 text-bold font-weight-bold">
            Mostrando {{ itemsVista.length }} registros de {{ items.length }}
          </b-col>
          <b-col xl="4" lg="4" md="6" sm="12" class="text-right mb-1">
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
        </b-row>
      </b-card-body>

      <b-table hover responsive small sticky-header="58vh" class="position-relative" :items="itemsVista"
        :fields="fields" :filter="filter" :filter-included-fields="filterOn" :busy="loading" show-empty
        empty-text="No se encontraron datos en esta tabla."
        emptyFilteredText="No se encontraron datos con los parámetros ingresados.">
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(show_details)="row">
          <div class="text-nowrap">
            <feather-icon v-if="$can('create', 'Pr Ma Fe Area')" :id="`btn_${row.item.id}_editare`" icon="EditIcon"
              size="16" class="ml-1" @click="mostrarModalEditar(row.item)" v-b-tooltip.hover.top="'Editar Usuario'" />
            <b-badge :variant="status[1][row.item.estado]" class="ml-1">
              {{ status[0][row.item.estado] }}
            </b-badge>
          </div>
        </template>
        <template #head(sociedad)>
          <div class="text-nowrap">
            <b-dropdown menu-class="" size="sm" variant="btn"
              :toggle-class="`${sociedad_filtro.length > 0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
              :style="`${sociedad_filtro.length > 0 ? 'text-decoration: underline #fba820e6;' : ''}`">
              <template #button-content>
                <b>SOCIEDAD</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Sociedad" label-for="sociedad_filtro" @click.prevent class="py-0 my-0">
                  <v-select id="sociedad_filtro" v-model="sociedad_filtro" :options="sociedadFiltro" multiple
                    placeholder="Seleccionar sociedad ..." @input="realizarFiltro('sociedad', sociedad_filtro)"
                    class="select-size-sm" />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="sociedad_filtro = []; realizarFiltro('sociedad', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
    </b-card>

    <b-modal id="modal-crear" ref="modal-crear" v-model="modalShowCrear" title="Crear Registro" ok-title="Crear"
      @show="resetModal" no-close-on-backdrop centered size="lg" @ok="okModalCrear">
      <div v-if="loadingCrear" align="center">
        <p>Editando registro ... </p>
        <b-spinner label="Loading..." variant="primary" />
      </div>
      <div v-else>
        <validation-observer ref="CrearResponsables">
          <b-form autocomplete="off" @submit.prevent="CrearUsuario">
            <b-row>
              <b-col lg="6">
                <b-form-group label="DNI" label-for="dni">
                  <b-input-group>
                    <b-form-input type="number" id="dni" v-model="dataArray.con_usuario.dni" name="dni" />
                    <b-input-group-append>
                      <b-button variant="primary" class="btn-icon" block @click="buscarUsuario"
                        :disabled="!dataArray.con_usuario.dni">
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Nombres" label-for="nombres">
                  <b-form-input id="nombres" v-model="dataArray.con_usuario.first_name" disabled />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Apellidos" label-for="apellidos">
                  <b-form-input id="apellidos" v-model="dataArray.con_usuario.last_name" disabled />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Usuario" label-for="usuario">
                  <b-form-input id="usuario" v-model="dataArray.con_usuario.username" disabled />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Seleccionar Estado" label-for="estado">
                  <v-select id="estado" v-model="dataArray.estado" :reduce="estados => estados.value" label="text"
                    key="value" :options="estados" :clearable="false" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Seleccionar Empresa" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.empresa" :options="empresas" :clearable="false" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Seleccionar Cultivo" label-for="cultivo">
                  <validation-provider #default="{ errors }" name="Cultivo" vid="cultivo" rules="required">
                    <v-select id="cultivo" v-model="dataArray.cultivo" :options="cultivos" multiple
                      @input="cambiarSelectCultivo" :clearable="false" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Seleccionar Rol" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.rol" :options="roles" :clearable="false" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Sem. Actual Día" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.valor" :options="diasSem" :clearable="false" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Sem. Actual Hora" label-for="hora1">
                  <validation-provider #default="{ errors }" name="Sem. Actual Hora" vid="hora1" rules="required">
                    <b-form-timepicker id="hora1" v-model="dataArray.valor_1" v-bind="espanol" now-button reset-button
                      locale="en" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Sem. Sgte. Día" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.valor_2" :options="diasSem" :clearable="false" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Sem. Sgte. Hora" label-for="hora2">
                  <validation-provider #default="{ errors }" name="Sem. Sgte. Hora" vid="hora2" rules="required">
                    <b-form-timepicker id="hora2" v-model="dataArray.valor_3" v-bind="espanol" now-button reset-button
                      locale="en" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Cód. Responsable" label-for="cod_resp">
                  <b-form-input id="cod_responsable" v-model="dataArray.cod_responsable" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Nombre Responsable" label-for="responsable">
                  <b-form-input id="responsable" v-model="dataArray.responsable" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>

    <b-modal id="modal-editar" ref="modal-editar" v-model="modalShowEditar" title="Editar Registro" ok-title="Editar"
      cancel-title="Cerrar" :cancel-disabled="loadingEditar" :ok-disabled="loadingEditar" no-close-on-esc
      no-close-on-backdrop centered size="lg" @ok="okModalEditar">
      <div v-if="loadingEditar" align="center">
        <p>Editando registro ... </p>
        <b-spinner label="Loading..." variant="primary" />
      </div>
      <div v-else>
        <validation-observer ref="editarResponsables">
          <b-form autocomplete="off" @submit.prevent="editarRegistro">
            <b-row>
              <b-col lg="6">
                <b-form-group label="Nombres" label-for="nombres">
                  <b-form-input id="nombres" v-model="dataArray.con_usuario.first_name" disabled />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Apellidos" label-for="apellidos">
                  <b-form-input id="apellidos" v-model="dataArray.con_usuario.last_name" disabled />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="DNI" label-for="dni">
                  <b-form-input id="dni" v-model="dataArray.con_usuario.dni" disabled />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Usuario" label-for="usuario">
                  <b-form-input id="usuario" v-model="dataArray.con_usuario.username" disabled />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Seleccionar Estado" label-for="estado">
                  <v-select id="estado" v-model="dataArray.estado" :reduce="estados => estados.value" label="text"
                    key="value" :options="estados" :clearable="false" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Seleccionar Empresa" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.empresa" :options="empresas" :clearable="false" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Seleccionar Cultivo" label-for="cultivo">
                  <validation-provider #default="{ errors }" name="Cultivo" vid="cultivo" rules="required">
                    <v-select id="cultivo" v-model="dataArray.cultivo" :options="cultivos" multiple
                      @input="cambiarSelectCultivo" :clearable="false" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Seleccionar Rol" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.rol" :options="roles" :clearable="false" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Sem. Actual Día" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.valor" :options="diasSem" :clearable="false" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Sem. Actual Hora" label-for="hora1">
                  <validation-provider #default="{ errors }" name="Sem. Actual Hora" vid="hora1" rules="required">
                    <b-form-timepicker id="hora1" v-model="dataArray.valor_1" v-bind="espanol" now-button reset-button
                      locale="en" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Sem. Sgte. Día" label-for="vue-select">
                  <v-select id="rol" v-model="dataArray.valor_2" :options="diasSem" :clearable="false" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Sem. Sgte. Hora" label-for="hora2">
                  <validation-provider #default="{ errors }" name="Sem. Sgte. Hora" vid="hora2" rules="required">
                    <b-form-timepicker id="hora2" v-model="dataArray.valor_3" v-bind="espanol" now-button reset-button
                      locale="en" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Cód. Responsable" label-for="cod_resp">
                  <b-form-input id="cod_responsable" v-model="dataArray.cod_responsable" />
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group label="Nombre Responsable" label-for="responsable">
                  <b-form-input id="responsable" v-model="dataArray.responsable" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>
  </div>
</template>
<script>
import axiosIns from '@/libs/axios'
import vSelect from 'vue-select'

import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BPagination,
  BSpinner,
  BTable,
  BRow,
  BCol,
  BFormTimepicker,
  BDropdownDivider,
  BInputGroup, BInputGroupAppend, BTooltip,
  BFormCheckbox,
  BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader,
  VBTooltip
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCard,
    BFormTimepicker,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BInputGroup,
    BInputGroupAppend,
    BTooltip,
    BFormCheckbox,
    BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [heightTransition],
  data: () => ({
    //Campos del Modelo
    sociedad: null,
    tipo: null,
    categoria: null,
    area_cultivo: null,
    fundo: null,
    etapa: null,
    campo: null,
    turno: null,
    cod_homologado: null,
    variedad: null,
    area_sembrada: null,
    area_total: null,

    roles: ['ADMINISTRADOR', 'APROBADOR', 'USUARIO'],
    empresas: ['TODOS', 'AGROVISIÓN PERÚ S.A.C', 'ARENA VERDE'],
    cultivos: ['TODOS', 'ARANDANO', 'UVA', 'PALTA', 'ESPARRAGO'],
    diasSem: ['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO', 'DOMINGO'],

    dataArray: {
      id: null,
      con_usuario: {
        id: null,
        username: null,
        first_name: null,
        last_name: null,
        dni: null
      },
      empresa: null,
      cultivo: null,
      rol: null,
      valor: null,
      valor_1: null,
      valor_2: null,
      valor_3: null,
      estado: null,
    },

    filterOn: [],

    loadingBP: false,

    loading: false,
    loadingEditar: false,
    loadingCrear: false,
    loadingExp: false,
    filter: null,

    items: [],
    fields: [
      {
        key: 'show_details',
        label: 'Estado',
        thClass: 'py-0 alinear-medio',
        class: 'text-center',
        stickyColumn: true
      },
      {
        key: 'sociedad',
        label: 'Sociedad',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'con_usuario.first_name',
        label: 'Nombres',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'con_usuario.last_name',
        label: 'Apellidos',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'con_usuario.dni',
        label: 'DNI',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'con_usuario.username',
        label: 'Usuario',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },

      {
        key: 'cultivo',
        label: 'Cultivo',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'rol',
        label: 'Rol',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'valor',
        label: 'Sem. Actual Día',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'valor_1',
        label: 'Sem. Actual Hora',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'valor_2',
        label: 'Sem. Sgte. Día',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'valor_3',
        label: 'Sem. Sgte. Hora',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'cod_responsable',
        label: 'Cód. Responsable',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'nombre_responsable',
        label: 'Nombre Responsable',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
    ],

    status: [
      {
        'A': 'Activo',
        // 1: 'Inactivo',
        'I': 'Inactivo',
        // 3: 'Eliminado',
      },
      {
        'A': 'light-success',
        // 1: 'light-warning',
        'I': 'light-danger',
        // 3: 'light-dark',
      }
    ],

    estados: [
      { value: 'A', text: "Activo" },
      // { value: '1', text: "Siembra" },
      { value: 'I', text: "Inactivo" },
      // { value: '3', text: "Eliminado" },
    ],

    modalShowEditar: false,
    modalShowCrear: false,
    multiple: false,

    itemsVista: [],

    filtro: [
      { nombre: "sociedad", valor: [] },
    ],

    sociedadFiltro: [],
    sociedad_filtro: [],

    espanol: {
      labelHours: 'Hora',
      labelMinutes: 'Minuto',
      labelSeconds: 'Segundos',
      labelIncrement: 'Erhöhen',
      labelDecrement: 'Verringern',
      labelSelected: 'Ausgewählte Zeit',
      labelNoTimeSelected: 'Seleccione Hora',
      labelCloseButton: 'Cerrar',
      labelResetButton: 'Borrar',
      labelNowButton: 'Ahora',
    },

    required,
  }),
  computed: {},

  mounted() {
    this.traerData();
    localize("es");
  },

  methods: {
    buscarUsuario() {
      const yo = this
      if (yo.dataArray.con_usuario.dni.length == 8) {
        yo.loadingBP = true
        const data = JSON.stringify({ 'dni': yo.dataArray.con_usuario.dni })
        const config = {
          method: 'post',
          url: '/pagricolas/Obtener/usuario/',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        }
        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              if (response.data['estado'] === true) {
                yo.dataArray.con_usuario.username = response.data['data']['username']
                yo.dataArray.con_usuario.first_name = response.data['data']['first_name']
                yo.dataArray.con_usuario.last_name = response.data['data']['last_name']
                yo.dataArray.con_usuario.id = response.data['data']['id']
              } else {
                yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro dni Registrado.", 'warning', 2000)
                yo.responsable_reg = null
              }
            }
          })
          .catch(function (error) {
            yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontro dni Registrado.", 'warning', 2000)
            yo.responsable_reg = null
          })
          .finally(function () {
            yo.loadingBP = false
          })
      } else {
        yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "Error al Digitar DNI, Intente nuevament.", 'warning', 2000)
      }
    },
    traerData() {
      const yo = this
      yo.loading = true
      const config = {
        method: 'get',
        url: '/pagricolas/responsables_maq/'
      }
      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            yo.items = response.data
            yo.sociedadFiltro = []
            for (let value of yo.items) {
              if (value.empresa !== null && value.empresa !== '' && value.empresa !== ' ' && value.empresa !== '  ') {
                yo.sociedadFiltro.push(value.sociedad)
              }
            }

            yo.sociedadFiltro = [...new Set(yo.sociedadFiltro)].sort()
            yo.sociedadFiltro.push('VACIOS')
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loading = false
          yo.realizarFiltro('', [])
        })
    },

    okModalEditar(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.editarRegistro()
    },
    okModalCrear(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.CrearUsuario()
    },

    cambiarSelectCultivo() {
      if (this.dataArray.cultivo[0] === "TODOS") {
        this.dataArray.cultivo = this.dataArray.cultivo.splice(1, 1)
      }
      if (this.dataArray.cultivo.includes("TODOS")) {
        this.dataArray.cultivo = ["TODOS"]
      }
    },

    CrearUsuario() {
      const yo = this
      this.$refs.CrearResponsables.validate().then(success => {
        if (success) {
          yo.modalShowCrear = true
          const data = JSON.stringify({
            'cod_responsable': yo.dataArray.cod_responsable,
            'nombre_responsable': yo.dataArray.responsable,
            'sociedad': yo.dataArray.empresa,
            'cultivo': yo.dataArray.cultivo.join(", "),
            'rol': yo.dataArray.rol,
            'valor': yo.dataArray.valor,
            'valor_1': yo.dataArray.valor_1,
            'valor_2': yo.dataArray.valor_2,
            'valor_3': yo.dataArray.valor_3,
            'con_usuario': yo.dataArray.con_usuario.id,
            'estado': yo.dataArray.estado,
          })
          const config = {
            method: 'post',
            url: 'pagricolas/usuario_maq/crear/',
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }
          axiosIns(config).then(function (response) {
            console.log(response.status)
            if (response.status === 201) {
              yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se realizó correctamente.", 'success', 5000)
            }
          })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro del Usuario.', 'BellIcon', error.toString(), 'danger', 5000)
            })
            .finally(function () {
              yo.traerData()
              yo.$nextTick(() => {
                yo.$refs['modal-crear'].toggle('#toggle-btn')
              })
              yo.loadingEditar = false
            })

        }
      })
    },
    mostrarModalEditar(arrData) {
      const yo = this
      const culti = arrData.cultivo.split(", ")
      yo.modalShowEditar = true
      yo.dataArray = {
        id: arrData.id,
        con_usuario: {
          id: arrData.con_usuario.id,
          username: arrData.con_usuario.username,
          first_name: arrData.con_usuario.first_name,
          last_name: arrData.con_usuario.last_name,
          dni: arrData.con_usuario.dni,
        },
        empresa: arrData.sociedad,
        cultivo: culti,
        rol: arrData.rol,
        valor: arrData.valor,
        valor_1: arrData.valor_1,
        valor_2: arrData.valor_2,
        valor_3: arrData.valor_3,
        estado: arrData.estado,
        cod_responsable: arrData.cod_responsable,
        responsable: arrData.nombre_responsable,
      }
    },

    editarRegistro() {
      const yo = this
      yo.$refs.editarResponsables.validate().then(success => {
        if (success) {
          yo.loadingEditar = true
          const data = JSON.stringify({
            'sociedad': yo.dataArray.empresa,
            'cultivo': yo.dataArray.cultivo.join(", "),
            'rol': yo.dataArray.rol,
            'valor': yo.dataArray.valor,
            'valor_1': yo.dataArray.valor_1,
            'valor_2': yo.dataArray.valor_2,
            'valor_3': yo.dataArray.valor_3,
            'estado': yo.dataArray.estado,
            'con_usuario': yo.dataArray.con_usuario.id,
            'cod_responsable': yo.dataArray.cod_responsable,
            'nombre_responsable': yo.dataArray.responsable,
          })
          const config = {
            method: 'put',
            url: 'pagricolas/usuario_maq/editar/' + yo.dataArray.id,
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }
          axiosIns(config).then(function (response) {
            if (response.status === 200) {
              yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó correctamente.", 'success', 5000)
            }
          })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en la edición.', 'BellIcon', error.toString(), 'danger', 5000)
            })
            .finally(function () {
              yo.traerData()
              yo.$nextTick(() => {
                yo.$refs['modal-editar'].toggle('#toggle-btn')
              })
              yo.loadingEditar = false
            })

        }
      })
    },

    exportarDataExcel() {
      const yo = this
      yo.loadingExp = true

      const config = {
        method: 'get',
        url: '/pagricolas/Responsables/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', "Responsable.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();

            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Archivo Generado',
                icon: 'CheckIcon',
                text: 'El archivo se creó satisfactoriamente.',
                variant: 'success',
              },
            },
              {
                position: 'top-center',
              })
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error en la creación del archivo',
              icon: 'XIcon',
              text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
              variant: 'danger',
            },
          })
        })
        .finally(function () {
          yo.loadingExp = false
        });
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: titulo,
          icon: icono,
          text: texto,
          variant: variante
        }
      },
        {
          timeout: tiempo,
          position: 'top-center',
        })
    },

    realizarFiltro(cabecera, data) {
      const yo = this

      let spd = yo.items

      let filt = []
      let c = 0
      for (const valor of yo.filtro) {
        if (valor.nombre === cabecera) {
          yo.filtro[c].valor = data
        }
        c += 1;
      }

      for (const values of yo.filtro) {
        for (const column of values.valor) {
          spd.forEach(function (value) {
            if (column === 'VACIOS') {
              if (value[values.nombre] === null || value[values.nombre] === '' || value[values.nombre] === ' ' || value[values.nombre] === '  ') {
                filt.push(value)
              }
            } else {
              if (value[values.nombre] === column) {
                filt.push(value)
              }
            }
          })
        }

        if (values.valor.length > 0) {
          if (values.valor[0] !== null) {
            spd = filt
            filt = []
          }
        }
      }

      yo.itemsVista = spd

    },
    resetModal() {
      this.dataArray.con_usuario.dni = null
      this.dataArray.con_usuario.username = null
      this.dataArray.con_usuario.first_name = null
      this.dataArray.con_usuario.last_name = null

      this.dataArray.empresa = null
      this.dataArray.cultivo = null
      this.dataArray.rol = null
      this.dataArray.valor = null
      this.dataArray.valor_1 = null
      this.dataArray.valor_2 = null
      this.dataArray.valor_3 = null
      this.dataArray.estado = null
      this.dataArray.con_usuario.id = null
      this.dataArray.cod_responsable = null
      this.dataArray.responsable = null
    },

    borrarFiltroGeneral() {
      this.sociedad_filtro = []
      this.filtro = [
        { nombre: "sociedad", valor: [] },
      ]
      this.itemsVista = this.items
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.alinear-una-sola-linea {
  white-space: nowrap !important;
}

.alinear-medio {
  vertical-align: middle !important;
}

.tenue-amarillo {
  background-color: rgba(204, 190, 41, 0.1);
}

.tenue-rojo {
  background-color: rgba(204, 68, 41, 0.1);
}

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
